// onkan-frontend specific
import WomanIcon from '@mui/icons-material/Woman';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import GavelIcon from '@mui/icons-material/Gavel';
import PetsIcon from '@mui/icons-material/Pets';
import ContentCutIcon from '@mui/icons-material/ContentCut';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import HourglassTopIcon from '@mui/icons-material/HourglassTop';
import LandscapeIcon from '@mui/icons-material/Landscape';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import LightModeIcon from '@mui/icons-material/LightMode';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BackpackIcon from '@mui/icons-material/Backpack';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import Face4Icon from '@mui/icons-material/Face4';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import GrassIcon from '@mui/icons-material/Grass';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import SchoolIcon from '@mui/icons-material/School';
import WineBarIcon from '@mui/icons-material/WineBar';
import AirIcon from '@mui/icons-material/Air';
import Face3Icon from '@mui/icons-material/Face3';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ForestIcon from '@mui/icons-material/Forest';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HearingIcon from '@mui/icons-material/Hearing';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import StartIcon from '@mui/icons-material/Start';
import TuneIcon from '@mui/icons-material/Tune';
import Filter6Icon from '@mui/icons-material/Filter6';
import RiceBowlIcon from '@mui/icons-material/RiceBowl';
import PestControlIcon from '@mui/icons-material/PestControl';
import BalanceIcon from '@mui/icons-material/Balance';
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import PestControlRodentIcon from '@mui/icons-material/PestControlRodent';
import ExpandIcon from '@mui/icons-material/Expand';
import CategoryIcon from '@mui/icons-material/Category';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SailingIcon from '@mui/icons-material/Sailing';
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import SickIcon from '@mui/icons-material/Sick';
import CasinoIcon from '@mui/icons-material/Casino';
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import BatteryChargingFullIcon from '@mui/icons-material/BatteryChargingFull';
import RuleIcon from '@mui/icons-material/Rule';
import MemoryIcon from '@mui/icons-material/Memory';
import HotelIcon from '@mui/icons-material/Hotel';
import WarningIcon from '@mui/icons-material/Warning';
import WavesIcon from '@mui/icons-material/Waves';


//

//export const API_BASE_URL = "http://localhost:8000";
//export const API_BASE_URL = "http://0.0.0.0:8000";
export const API_BASE_URL = "https://gallerylambda.com";
export const API_SIGN_UP_PATH = "/api/dj-rest-auth/registration/";
export const API_TOKEN_PATH = "/api/token/";
export const API_REFRESH_PATH = "/api/token/refresh/"
export const API_PERMISSION_REQUIRED_TEST_PATH = "/api/"
export const API_USERNAME_PATH = "/api/auth/username/"
export const API_VOTE_PATH = "/api/community/create-user-vote/"
export const API_SUGGEST_PATH = "/api/community/suggest-choice-by-category/"
export const API_GET_CHOICES_PATH = "/api/community/get-choices-by-category/"
export const API_GET_VOTE_PATH = "/api/community/get-upvote-by-choice/"
export const API_GET_USER_PROFILE = "/api/auth/get-user-profile/"
export const API_DELETE_USER_PROFILE = "/api/auth/get-delete-user-profile/"
export const API_LOGOUT = "/api/auth/logout/"
export const UI_SIGN_IN_PATH = "/sign-in/"
export const UI_BOOK1 = "/book1/"
export const UI_COFFEE_BREAK = "/coffee-break/"
export const UI_BOOK2 = "/book2/"
export const UI_CREDIT_CARD = "/credit-card/"
export const UI_HER = "/her/"
export const UI_EC = "/ec/"
export const UI_MOBILE_CARRIER = "/mobile-carrier/"
export const UI_FURNITURE_AND_ELECTRONICS = "/year-and-ear/"
export const UI_OTHERS = "/final-step/"
export const UI_SELF_SERVICE = "/account/"
export const TIME_DELAY_MSEC = 3000
export const API_SCORE_HER_VOICE_PATH = "/api/v1/inference/score_her_voice/"
export const API_GET_HER_STATS = "/api/v1/inference/her_stats/"
export const RECORD_SAMPLING_RATE = 22050 // if smaller, lower transmit but heavy calc at server side
export const VOLUME_THRESHOLD = 0.002

// biz-professional-frontend specific
export const UI_ISSUE = "/issue-analysis"
export const UI_SLIDE_STRUCTURE = "/slide-structure"
export const UI_TOP_MESSAGE = "/top-message"
export const UI_DESIGN = "/design"
export const UI_BOTTOM = "/bottom-message"
export const UI_SUMMARY = "/executive-summary"
export const UI_PRESENTATIONS = "/consulting-presentations"
export const UI_PROFESSIONAL_BOOKS = "/professional-books"
export const UI_EPILOGUE = "/epilogue"


// onkan-frontend specific
export const UI_BASE_URL = "https://etudes.l-capital.dev";
export const GA_ID = "G-X5D0WZW0KM"
export const API_HAS_ALL_CLIENT_ORG_LICENSE_STATUS_PATH = "/api/internal/v1/auth/user/rights/has-all-client-org-license-status/";
export const getHasAllClientOrgRolesPath = (username: string) =>
    `/api/internal/v1/auth/user/${username}/rights/has-all/`;
export const API_HAS_ALL_CLIENT_ORG_ROLES_PATH = "/api/internal/v1/auth/user/rights/has-all-client-org-roles/"
export const API_CREATE_EXAM_PATH = "/api/onso/create-exam/";
export const API_STORE_EXAM_RESULT_PATH = "/api/onso/store-exam-result/";
export const API_FETCH_EXAM_UUID = "/api/onso/fetch-exam-uuid/";
export const API_FETCH_EXAM_RESULT_PATH = "/api/onso/fetch-exam-result/";
export const API_FETCH_EXAM_RESULT_PER_UUID_PATH = "/api/onso/fetch-exam-result-per-uuid/";
export const API_FETCH_EXAM_RESULT_PER_ORG_PATH = "/api/onso/fetch-exam-result-per-organization/";
export const API_FETCH_ORG_USERS_DATA_PATH = "/api/onso/fetch-organization-user-data/";
export const API_CREATE_APP_USER = "/api/onso/create-app-user/";
export const API_UPDATE_APP_USER = "/api/onso/update-app-user/";
export const API_CREATE_CLASS = "/api/onso/create-class/";
export const API_UPDATE_CLASS = "/api/onso/update-class/";
export const UI_COACHING = "/coaching"
export const UI_TEST = "/test"
export const UI_RESULT = "/result"
export const UI_ORG_STATS = "/stats"
export const UI_USER_ADMIN = "/user-admin"


type QuizData = {
    word: string;
    targetOnso: string;
    pronauniation: string;
    color: string;
    icon: any;
};

// Define the overall structure with multiple quizzes
export const QUIZ_DATA: {
    [key: string]: QuizData[];
} = {
    quiz1: [
        {
            word: "heard",
            targetOnso: "ə́ː",
            pronauniation: "hə́ːrd",
            color: "#e3f2fd",
            icon: AudiotrackIcon,
        },
        {
            word: "hard",
            targetOnso: "ɑː",
            pronauniation: "hɑːrd",
            color: "#f3e5f5",
            icon: GavelIcon,
        },
    ],
    quiz2: [
        {
            word: "cat",
            targetOnso: "æ",
            pronauniation: "kˈæt",
            color: "#e3f2fd",
            icon: PetsIcon,
        },
        {
            word: "cut",
            targetOnso: "ʌ",
            pronauniation: "kˈʌt",
            color: "#e0e0e0",
            icon: ContentCutIcon,
        },

    ],
    quiz3: [
        {
            word: "wait",
            targetOnso: "éɪ",
            pronauniation: "wéɪt",
            color: "#f3e5f5",
            icon: HourglassTopIcon,
        },
        {
            word: "wet",
            targetOnso: "é",
            pronauniation: "wét",
            color: "#e3f2fd",
            icon: WaterDropIcon,
        },

    ],
    quiz4: [
        {
            word: "hat",
            targetOnso: "æ",
            pronauniation: "hˈæt",
            color: "#e3f2fd",
            icon: LandscapeIcon,
        },
        {
            word: "hot",
            targetOnso: "ά",
            pronauniation: "hάt",
            color: "e3f2fd",
            icon: LocalFireDepartmentIcon,
        },

    ],
    quiz5: [
        {
            word: "pay",
            targetOnso: "éɪ",
            pronauniation: "péɪ",
            color: "#fce4ec",
            icon: HourglassTopIcon,
        },
        {
            word: "pea",
            targetOnso: "íː",
            pronauniation: "píː",
            color: "#f3e5f5",
            icon: WaterDropIcon,
        },

    ],
    quiz6: [
        {
            word: "wait",
            targetOnso: "éɪ",
            pronauniation: "wéɪt",
            color: "#f3e5f5",
            icon: HourglassTopIcon,
        },
        {
            word: "wet",
            targetOnso: "é",
            pronauniation: "wét",
            color: "#e3f2fd",
            icon: WaterDropIcon,
        },

    ],
    quiz7: [
        {
            word: "work",
            targetOnso: "ɚː",
            pronauniation: "wˈɚːk",
            color: "#e3f2fd",
            icon: FitnessCenterIcon,
        },
        {
            word: "walk",
            targetOnso: "ɔː",
            pronauniation: "wˈɔːk",
            color: "#e3f2fd",
            icon: DirectionsRunIcon,
        },


    ],
    quiz8: [
        {
            word: "walk",
            targetOnso: "ɔː",
            pronauniation: "wˈɔːk",
            color: "#e3f2fd",
            icon: DirectionsRunIcon,
        },
        {
            word: "woke",
            targetOnso: "óʊ",
            pronauniation: "wóʊk",
            color: "#f3e5f5",
            icon: LightModeIcon,
        },

    ],
    quiz9: [
        {
            word: "mart",
            targetOnso: "ά",
            pronauniation: "mάɚt",
            color: "#e3f2fd",
            icon: ShoppingCartIcon,
        },
        {
            word: "might",
            targetOnso: "ɑɪ",
            pronauniation: "mɑɪt",
            color: "#f3e5f5",
            icon: PsychologyAltIcon,
        },

    ],
    quiz10: [
        {
            word: "fond",
            targetOnso: "ά",
            pronauniation: "fάnd",
            color: "#e3f2fd",
            icon: FavoriteBorderIcon,
        },
        {
            word: "found",
            targetOnso: "άʊ",
            pronauniation: "fάʊnd",
            color: "#f3e5f5",
            icon: SearchIcon,
        },

    ],
    quiz11: [
        {
            word: "back",
            targetOnso: "b",
            pronauniation: "bˈæk",
            color: "#fce4ec",
            icon: ArrowBackIcon,
        },
        {
            word: "pack",
            targetOnso: "p",
            pronauniation: "pˈæk",
            color: "#fce4ec",
            icon: BackpackIcon,
        },

    ],
    quiz12: [
        {
            word: "zoo",
            targetOnso: "z",
            pronauniation: "zúː",
            color: "#fce4ec",
            icon: NaturePeopleIcon,
        },
        {
            word: "sue",
            targetOnso: "s",
            pronauniation: "súː",
            color: "#fce4ec",
            icon: Face4Icon,
        },

    ],
    quiz13: [
        {
            word: "down",
            targetOnso: "d",
            pronauniation: "dάʊn",
            color: "#fce4ec",
            icon: TrendingDownIcon,
        },
        {
            word: "town",
            targetOnso: "t",
            pronauniation: "tάʊn",
            color: "#fce4ec",
            icon: LocationCityIcon,
        },

    ],
    quiz14: [
        {
            word: "leaf",
            targetOnso: "f",
            pronauniation: "líːf",
            color: "#fce4ec",
            icon: GrassIcon,
        },
        {
            word: "leave",
            targetOnso: "v",
            pronauniation: "líːv",
            color: "#e3f2fd",
            icon: WavingHandIcon,
        },

    ],
    quiz15: [
        {
            word: "class",
            targetOnso: "k",
            pronauniation: "klˈæs",
            color: "#fce4ec",
            icon: SchoolIcon,
        },
        {
            word: "glass",
            targetOnso: "g",
            pronauniation: "glˈæs",
            color: "#fce4ec",
            icon: WineBarIcon,
        },

    ],
    quiz16: [
        {
            word: "air",
            targetOnso: "",
            pronauniation: "éɚ",
            color: "#f3e5f5",
            icon: AirIcon,
        },
        {
            word: "hair",
            targetOnso: "h",
            pronauniation: "héɚ",
            color: "#fce4ec",
            icon: Face3Icon,
        },

    ],
    quiz17: [
        {
            word: "good",
            targetOnso: "",
            pronauniation: "gˈʊd",
            color: "#e0e0e0",
            icon: ThumbUpOffAltIcon,
        },
        {
            word: "wood",
            targetOnso: "w",
            pronauniation: "wˈʊd",
            color: "#e3f2fd",
            icon: ForestIcon,
        },

    ],
    quiz18: [
        {
            word: "year",
            targetOnso: "j",
            pronauniation: "jíɚ",
            color: "#e3f2fd",
            icon: CalendarMonthIcon,
        },
        {
            word: "ear",
            targetOnso: "í",
            pronauniation: "íɚ",
            color: "#fce4ec",
            icon: HearingIcon,
        },

    ],
    quiz19: [
        {
            word: "sort",
            targetOnso: "s",
            pronauniation: "sˈɔɚt",
            color: "#fce4ec",
            icon: SortByAlphaIcon,
        },
        {
            word: "short",
            targetOnso: "ʃ(sh)",
            pronauniation: "ʃˈɔɚt",
            color: "#f3e5f5",
            icon: StartIcon,
        },

    ],
    quiz20: [
        {
            word: "tune",
            targetOnso: "t",
            pronauniation: "t(j)úːn",
            color: "#e3f2fd",
            icon: TuneIcon,
        },
        {
            word: "june",
            targetOnso: "dʒ(j)",
            pronauniation: "dʒúːn",
            color: "#e3f2fd",
            icon: Filter6Icon,
        },

    ],
    quiz21: [
        {
            word: "rice",
            targetOnso: "r",
            pronauniation: "rάɪs",
            color: "#e3f2fd",
            icon: RiceBowlIcon,
        },
        {
            word: "lice",
            targetOnso: "l",
            pronauniation: "laɪs",
            color: "#fce4ec",
            icon: PestControlIcon,
        },

    ],
    quiz22: [
        {
            word: "far",
            targetOnso: "ά",
            pronauniation: "fάɚ",
            color: "#f3e5f5",
            icon: SocialDistanceIcon,
        },
        {
            word: "fair",
            targetOnso: "é",
            pronauniation: "féɚ",
            color: "#e3f2fd",
            icon: BalanceIcon,
        },
    ],
    quiz23: [
        {
            word: "nice",
            targetOnso: "n",
            pronauniation: "nάɪs",
            color: "#fce4ec",
            icon: ThumbUpOffAltIcon,
        },
        {
            word: "mice",
            targetOnso: "m",
            pronauniation: "mάɪs",
            color: "#f3e5f5",
            icon: PestControlRodentIcon,
        },
    ],
    quiz24: [
        {
            word: "beat",
            targetOnso: "íː",
            pronauniation: "bíːt",
            color: "#e3f2fd",
            icon: AudiotrackIcon,
        },
        {
            word: "bit",
            targetOnso: "í",
            pronauniation: "bít",
            color: "#fce4ec",
            icon: MemoryIcon,
        },
    ],
    quiz25: [
        {
            word: "thing",
            targetOnso: "ŋ",
            pronauniation: "θíŋ",
            color: "#e3f2fd",
            icon: CategoryIcon,
        },
        {
            word: "thin",
            targetOnso: "n",
            pronauniation: "θín",
            color: "#fce4ec",
            icon: ExpandIcon,
        },
    ],
    quiz26: [
        {
            word: "cost",
            targetOnso: "ɔː",
            pronauniation: "kˈɔːst",
            color: "#fce4ec",
            icon: MonetizationOnIcon,
        },
        {
            word: "coast",
            targetOnso: "óʊ",
            pronauniation: "kóʊst",
            color: "#f3e5f5",
            icon: SailingIcon,
        },
    ],
    quiz27: [
        {
            word: "want",
            targetOnso: "ά",
            pronauniation: "wάnt",
            color: "#fce4ec",
            icon: TipsAndUpdatesIcon,
        },
        {
            word: "won't",
            targetOnso: "óʊ",
            pronauniation: "wóʊnt",
            color: "#f3e5f5",
            icon: DoNotDisturbAltIcon,
        },
    ],
    quiz28: [
        {
            word: "can",
            targetOnso: "ə",
            pronauniation: "k(ə)n",
            color: "#fce4ec",
            icon: SentimentSatisfiedAltIcon,
        },
        {
            word: "can't",
            targetOnso: "æ",
            pronauniation: "kˈæːnt",
            color: "#e3f2fd",
            icon: CancelIcon,
        },
    ],
    quiz29: [
        {
            word: "sick",
            targetOnso: "s",
            pronauniation: "sík",
            color: "#fce4ec",
            icon: SickIcon,
        },
        {
            word: "thick",
            targetOnso: "θ(th)",
            pronauniation: "θík",
            color: "#e3f2fd",
            icon: ExpandIcon,
        },
    ],
    quiz30: [
        {
            word: "luck",
            targetOnso: "ʌ",
            pronauniation: "lˈʌk",
            color: "#e3f2fd",
            icon: CasinoIcon,
        },
        {
            word: "look",
            targetOnso: "ʊ",
            pronauniation: "lˈʊk",
            color: "#e3f2fd",
            icon: SavedSearchIcon,
        },
    ],
    quiz31: [
        {
            word: "full",
            targetOnso: "ʊ",
            pronauniation: "fˈʊl",
            color: "fce4ec",
            icon: BatteryChargingFullIcon,
        },
        {
            word: "fool",
            targetOnso: "úː",
            pronauniation: "fúːl",
            color: "#f3e5f5",
            icon: RuleIcon,
        },
    ],
    quiz32: [
        {
            word: "thin",
            targetOnso: "θ",
            pronauniation: "θɪn",
            color: "#e3f2fd",
            icon: ExpandIcon,
        },
        {
            word: "sin",
            targetOnso: "s",
            pronauniation: "sɪn",
            color: "#fce4ec",
            icon: GavelIcon,
        },
    ],
    quiz33: [
        {
            word: "bed",
            targetOnso: "é",
            pronauniation: "béd",
            color: "#e3f2fd",
            icon: HotelIcon,
        },
        {
            word: "bad",
            targetOnso: "æ",
            pronauniation: "bæd",
            color: "#f3e5f5",
            icon: WarningIcon,
        },
    ],
    quiz34: [
        {
            word: "she",
            targetOnso: "ʃ(sh)",
            pronauniation: "ʃíː",
            color: "#e3f2fd",
            icon: Face4Icon,
        },
        {
            word: "sea",
            targetOnso: "s",
            pronauniation: "síː",
            color: "#fce4ec",
            icon: WavesIcon,
        },
    ]
};

